/* Buffalo Barbecue Quest Travel Guide.
   Reads the blend library from <script id="guide-data">, renders the Essentials and
   protein pickers, and filters the blends to what the visitor can make. A blend asks
   for ingredients ("salt", "pepper"...), and any Essential that fills that ingredient
   satisfies it, so Salt Road and Pink Horizon both unlock every salt blend. Adding an
   Essential, a protein or a blend is a data change only.

   Every card is built once and keeps its place. A change only toggles classes and
   swaps text, and CSS animates the difference, so the page never jumps. */
(function () {
  var dataEl = document.getElementById("guide-data");
  var form = document.querySelector("[data-guide-form]");
  if (!dataEl || !form) return;

  var data = JSON.parse(dataEl.textContent);
  var STORE = "bbqq-guide";
  var FRACTIONS = { 0.25: "¼", 0.5: "½", 0.75: "¾" };
  var UNITS = { 1: ["tsp", "tsp"], 3: ["tbsp", "tbsp"], 12: ["cup", "cups"] };
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Line drawings for the Essentials buttons, 32px grid. A new Essential names one.
  var ICONS = {
    flakes: '<path d="M5 15l5-3 5 3-5 3zM16 8.5l4.5-2.5 4.5 2.5-4.5 2.5zM15 21l5-3 5 3-5 3z"/><path d="M8 25.5l2-1.2M24 14.5l2-1.2"/>',
    crystals: '<path d="M6 19l3.5-6.5 6.5-1 3.5 5.5-3.5 6.5-6.5 1z"/><path d="M9.5 12.5l3 5.5 7-1M12.5 18l-3 6.5"/><path d="M20 9.5l3-2.5 3.5 2-1 4.5h-4z"/>',
    peppercorns: '<circle cx="10.5" cy="12.5" r="4.5"/><circle cx="21" cy="11" r="4"/><circle cx="16" cy="21.5" r="4.5"/><path d="M8.5 12c1-1 3-1 4 0M19.5 10.5c.9-.8 2.2-.8 3 0M14 21c1-1 3-1 4 0"/>',
    garlic: '<path d="M16 6.5c0 3-2 4-5 6s-4.2 5-3.2 8c1.2 3.8 5 5.5 8.2 5.5s7-1.7 8.2-5.5c1-3-.2-6-3.2-8s-5-3-5-6z"/><path d="M16 12.5c-2 3.5-2 9 0 13.5M16 12.5c2 3.5 2 9 0 13.5M11.5 14.5c-2 3-1.5 7.5 1.5 10.5M20.5 14.5c2 3 1.5 7.5-1.5 10.5M16 6.5V3.5"/>',
    paprika: '<path d="M12.5 9.5c-3.5 1-4.6 4.4-3.6 8.4 1.2 4.8 4.4 8.4 8.6 10.6.9-3.2 2.2-6.2 4-9.3 2.2-3.9 2-7.9-1-9.6-2.2-1.2-5-1.2-8 0z"/><path d="M14.5 8.8c0-2.2 1.2-4.2 3.5-5.3l2 .8"/>',
    jar: '<rect x="9" y="10" width="14" height="17" rx="2"/><path d="M11 10V6h10v4"/>'
  };

  var state = { own: [], cook: [], batch: 3 };
  try {
    var saved = JSON.parse(localStorage.getItem(STORE));
    if (saved) state = Object.assign(state, saved);
  } catch (e) {}
  function save() {
    try { localStorage.setItem(STORE, JSON.stringify(state)); } catch (e) {}
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function list(words, joiner) {
    if (words.length < 2) return words.join("");
    return words.slice(0, -1).join(", ") + " " + joiner + " " + words[words.length - 1];
  }
  function proteinLabel(id) {
    var p = data.proteins.filter(function (x) { return x.id === id; })[0];
    return p ? p.label : id;
  }

  // Ingredient key -> the Essentials that fill it
  var fillers = {};
  data.essentials.forEach(function (e) { (fillers[e.fills] = fillers[e.fills] || []).push(e); });
  function colorOf(key) { var e = (fillers[key] || [])[0]; return e ? e.color : "#999"; }

  function ownedKeys() {
    var keys = {};
    data.essentials.forEach(function (e) { if (state.own.indexOf(e.id) > -1) keys[e.fills] = true; });
    return keys;
  }
  // Name an ingredient by the Essentials the visitor owns for it, or all of them
  function namedFillers(key) {
    var all = fillers[key] || [];
    var owned = all.filter(function (e) { return state.own.indexOf(e.id) > -1; });
    return owned.length ? owned : all;
  }
  function ingredientName(key) { return list(namedFillers(key).map(function (e) { return e.name; }), "or"); }
  function ingredientSpice(key) { return list(namedFillers(key).map(function (e) { return e.spice.toLowerCase(); }), "or"); }
  function shopUrl(key) { var e = (fillers[key] || [])[0]; return (e && e.url) || "#essentials"; }

  function amount(parts) {
    var unit = UNITS[state.batch];
    var n = state.batch === 12 ? parts / 4 : parts;
    var whole = Math.floor(n), frac = FRACTIONS[n - whole] || "";
    return (whole || !frac ? whole : "") + frac + " " + (n > 1 ? unit[1] : unit[0]);
  }

  /* ---------- Build once ---------- */
  var allLabel = "I have all " + ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"][data.essentials.length];
  $("[data-guide-essentials]").innerHTML = data.essentials.map(function (e) {
    return '<label class="card-essential" style="--tin: ' + esc(e.color) + '">' +
      '<input type="checkbox" name="own" value="' + esc(e.id) + '">' +
      '<span class="essential-icon" aria-hidden="true"><svg viewBox="0 0 32 32">' + (ICONS[e.icon] || ICONS.jar) + '</svg></span>' +
      '<span class="essential-name">' + esc(e.name) + '</span>' +
      '<span class="essential-spice">' + esc(e.spice) + '</span>' +
      '<svg class="essential-check" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5l4 4L18 8"/></svg>' +
      '</label>';
  }).join("") +
    '<button type="button" class="card-essential card-essential-all" data-guide-all>' +
    '<span class="essential-icon" aria-hidden="true"><svg viewBox="0 0 32 32"><path d="M8 16.5l5 5L24 10"/></svg></span>' +
    '<span class="essential-name">' + esc(allLabel) + '</span></button>';

  $("[data-guide-proteins]").innerHTML = data.proteins.map(function (p) {
    return '<label class="guide-pill"><input type="checkbox" name="cook" value="' + esc(p.id) + '"><span>' + esc(p.label) + '</span></label>';
  }).join("");

  // The lineup shows each label front; an Essential without label art falls back to its icon
  $("[data-guide-shop]").innerHTML = data.essentials.map(function (e) {
    var art = e.label
      ? '<img class="shop-label" src="' + esc(e.label) + '" width="640" height="837" loading="lazy" alt="' +
        esc(e.name + " " + e.spice + " label, " + (e.size || "")) + '">'
      : '<span class="shop-tin" aria-hidden="true"><svg viewBox="0 0 32 32">' + (ICONS[e.icon] || ICONS.jar) + '</svg></span>';
    return '<li class="card-shop" style="--tin: ' + esc(e.color) + '">' +
      '<a href="' + esc(e.url || "#essentials") + '">' + art +
      '<span class="shop-meta"><span class="essential-name">' + esc(e.name) + '</span>' +
      (e.size ? '<span class="shop-size tabular">' + esc(e.size) + '</span>' : '') + '</span>' +
      '<span class="essential-spice">' + esc(e.spice) + '</span></a>' +
      (e.description ? '<p class="shop-desc">' + esc(e.description) + '</p>' : '') + '</li>';
  }).join("");

  $("[data-guide-blends]").innerHTML = data.blends.map(function (blend, i) {
    var keys = Object.keys(blend.parts);
    var total = keys.reduce(function (sum, k) { return sum + blend.parts[k]; }, 0);
    var bar = keys.map(function (k) {
      return '<span data-key="' + esc(k) + '" data-share="' + blend.parts[k] + '/' + total + '" style="flex-grow: ' + blend.parts[k] + '; --tin: ' + esc(colorOf(k)) + '">' +
        '<span class="bar-tip" data-tip></span></span>';
    }).join("");
    var rows = keys.map(function (k) {
      return '<li data-key="' + esc(k) + '" style="--tin: ' + esc(colorOf(k)) + '">' +
        '<span class="blend-swatch" aria-hidden="true"></span>' +
        '<span class="blend-ingredient"><span data-name></span><small data-spice></small></span>' +
        '<span class="blend-parts tabular">' + blend.parts[k] + (blend.parts[k] > 1 ? " parts" : " part") + '</span>' +
        '<span class="blend-amount tabular" data-parts="' + blend.parts[k] + '"></span></li>';
    }).join("");
    return '<li class="card-blend" data-blend="' + i + '"><div class="card-blend-inner">' +
      '<button type="button" class="blend-toggle" aria-expanded="false" aria-controls="blend-' + i + '">' +
      '<span class="blend-head"><span class="blend-name">' + esc(blend.name) + '</span>' +
      '<span class="blend-for">' + esc(blend.great_for) + '</span></span>' +
      '<span class="blend-bar" aria-hidden="true">' + bar + '</span>' +
      '<span class="blend-status" data-status></span>' +
      '<svg class="blend-chevron" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>' +
      '</button>' +
      '<div class="guide-collapse blend-recipe" id="blend-' + i + '"><div class="guide-collapse-inner">' +
      '<ul class="list-blend-rows">' + rows + '</ul>' +
      '<p class="blend-yield">Makes about <span class="tabular" data-parts="' + total + '"></span>.</p>' +
      '</div></div></div></li>';
  }).join("");

  $$("input[name=own]", form).forEach(function (i) { i.checked = state.own.indexOf(i.value) > -1; });
  $$("input[name=cook]", form).forEach(function (i) { i.checked = state.cook.indexOf(i.value) > -1; });
  $$("input[name=batch]", form).forEach(function (i) { i.checked = Number(i.value) === state.batch; });

  /* ---------- Count tick ---------- */
  var countEl = $("[data-guide-count=makeable]");
  var shown = 0, tick;
  function setCount(to) {
    cancelAnimationFrame(tick);
    if (reduceMotion || to === shown) { countEl.textContent = shown = to; return; }
    var from = shown, start = performance.now(), dur = 320;
    (function step(now) {
      var t = Math.min(1, (now - start) / dur);
      shown = Math.round(from + (to - from) * (1 - Math.pow(1 - t, 3)));
      countEl.textContent = shown;
      if (t < 1) tick = requestAnimationFrame(step);
    })(start);
  }

  function setOpen(wrap, open) { wrap.classList.toggle("is-open", open); }

  /* ---------- Update in place ---------- */
  function render() {
    var keys = ownedKeys();
    var hasAny = state.own.length > 0;
    var visible = 0, makeable = 0, gain = {};

    data.blends.forEach(function (blend, i) {
      var card = $('[data-blend="' + i + '"]');
      var inPool = !state.cook.length || blend.proteins.some(function (p) { return state.cook.indexOf(p) > -1; });
      var missing = Object.keys(blend.parts).filter(function (k) { return !keys[k]; });
      card.classList.toggle("is-filtered", !inPool);
      card.classList.toggle("is-locked", hasAny && missing.length > 0);
      card.classList.toggle("is-ready", hasAny && !missing.length);
      if (inPool) {
        visible++;
        if (!missing.length) makeable++;
        if (missing.length === 1) gain[missing[0]] = (gain[missing[0]] || 0) + 1;
      }
      // Swatches take the color of the Essential the visitor would actually use
      $$("[data-key]", card).forEach(function (el) {
        el.style.setProperty("--tin", namedFillers(el.getAttribute("data-key"))[0].color);
      });
      // Hover readout on each bar segment: Essential, parts, amount at this batch, share
      $$("[data-share]", card).forEach(function (seg) {
        var share = seg.getAttribute("data-share").split("/").map(Number);
        var k = seg.getAttribute("data-key");
        $("[data-tip]", seg).textContent = ingredientName(k) + ": " + share[0] + (share[0] > 1 ? " parts, " : " part, ") +
          amount(share[0]) + ", about " + Math.round(share[0] / share[1] * 100) + "%";
      });
      $$(".list-blend-rows li", card).forEach(function (row) {
        var k = row.getAttribute("data-key");
        $("[data-name]", row).textContent = ingredientName(k);
        $("[data-spice]", row).textContent = ingredientSpice(k);
        row.classList.toggle("is-missing", hasAny && missing.indexOf(k) > -1);
      });
      var status = $("[data-status]", card);
      if (!hasAny) status.textContent = "";
      else if (!missing.length) status.textContent = "You can make this";
      else status.textContent = "Needs " + list(missing.map(ingredientName), "and");
    });

    $$("[data-parts]").forEach(function (el) { el.textContent = amount(Number(el.getAttribute("data-parts"))); });

    var cookWords = state.cook.map(function (id) { return proteinLabel(id).toLowerCase(); });
    var forWhat = cookWords.length ? " for " + list(cookWords, "or") : "";
    setCount(makeable);
    var summary;
    if (!hasAny) summary = "Tick the Essentials you own to see what you can make" + forWhat + ".";
    else if (!visible) summary = "blends" + forWhat + " so far.";
    else summary = (makeable === 1 ? "blend" : "blends") + " you can make" + forWhat + " right now" +
      (makeable < visible ? ", out of " + visible + " in the guide." : ". That's every one.");
    $("[data-guide-summary]").textContent = summary;

    // The single Essential that would unlock the most blends
    var best = Object.keys(gain).sort(function (a, b) { return gain[b] - gain[a]; })[0];
    if (best && hasAny) {
      $("[data-guide-unlock]").innerHTML = '<p>Add <strong>' + esc(ingredientName(best)) + '</strong> and you can make ' +
        gain[best] + ' more.</p><a class="btn" href="' + esc(shopUrl(best)) + '">Shop ' + esc(fillers[best][0].name) + '</a>';
    }
    setOpen($("[data-guide-unlock-wrap]"), !!(best && hasAny));

    $("[data-guide-empty-what]").textContent = cookWords.length ? list(cookWords, "or") : "that";
    setOpen($("[data-guide-empty-wrap]"), visible === 0);
  }

  form.addEventListener("change", function () {
    state.own = $$("input[name=own]:checked", form).map(function (i) { return i.value; });
    state.cook = $$("input[name=cook]:checked", form).map(function (i) { return i.value; });
    var b = $("input[name=batch]:checked", form);
    state.batch = b ? Number(b.value) : 3;
    save();
    render();
  });

  $("[data-guide-all]").addEventListener("click", function () {
    var boxes = $$("input[name=own]", form);
    var all = boxes.every(function (i) { return i.checked; });
    boxes.forEach(function (i) { i.checked = !all; });
    form.dispatchEvent(new Event("change"));
  });

  $("[data-guide-blends]").addEventListener("mouseover", function (e) {
    var seg = e.target.closest("[data-share]");
    var card = e.target.closest(".card-blend");
    if (!card) return;
    $$(".list-blend-rows li", card).forEach(function (row) {
      row.classList.toggle("is-hot", !!seg && row.getAttribute("data-key") === seg.getAttribute("data-key"));
    });
  });
  $("[data-guide-blends]").addEventListener("mouseleave", function () {
    $$(".list-blend-rows li.is-hot").forEach(function (row) { row.classList.remove("is-hot"); });
  }, true);

  $("[data-guide-blends]").addEventListener("click", function (e) {
    var btn = e.target.closest(".blend-toggle");
    if (!btn) return;
    var open = btn.getAttribute("aria-expanded") !== "true";
    btn.setAttribute("aria-expanded", open);
    setOpen(document.getElementById(btn.getAttribute("aria-controls")), open);
  });

  render();

  /* ---------- Tips stage: falling spice, cards land in turn ---------- */
  var tips = $("[data-guide-tips]");
  if (tips && !reduceMotion) {
    var fall = $("[data-guide-spice]", tips);
    // Real spice grains cut from public-domain photos (images/guide-spice-*.webp)
    var sprites = data.spice_sprites || [];
    var SIZES = { corn: [10, 18], flake: [8, 18], fleck: [6, 12] };
    var bits = "";
    for (var n = 0; sprites.length && n < 90; n++) {
      var sp = sprites[n % sprites.length];
      var range = SIZES[sp.kind] || SIZES.flake;
      var size = range[0] + Math.random() * (range[1] - range[0]);
      bits += '<span class="spice-bit" style="left:' + (Math.random() * 100).toFixed(1) + '%;' +
        'width:' + size.toFixed(1) + 'px;height:' + size.toFixed(1) + 'px;' +
        'background-image:url(' + sp.src + ');--o:' + (0.6 + Math.random() * 0.4).toFixed(2) + ';' +
        '--d:' + (14 + Math.random() * 16).toFixed(1) + 's;--delay:-' + (Math.random() * 30).toFixed(1) + 's;' +
        '--drift:' + (Math.random() * 80 - 40).toFixed(0) + 'px;--spin:' + (Math.random() * 720 - 360).toFixed(0) + 'deg"></span>';
    }
    fall.innerHTML = bits;

    var cards = $$(".card-tip", tips);
    var track = $(".guide-tips-track", tips);
    var ticking = false;
    function onScroll() {
      ticking = false;
      var rect = track.getBoundingClientRect();
      var span = rect.height - window.innerHeight;
      var scrolled = -rect.top;
      var p = Math.min(1, Math.max(0, scrolled / span));
      // Fixed pixels so it feels the same on any screen: a landing every 200px (about two
      // mouse-wheel clicks), and the pin (640px, set on the track) lets go two clicks later
      cards.forEach(function (card, i) { card.classList.toggle("is-in", scrolled > 30 + i * 200); });
      // The spice drifts up a little with the scroll, so the stage feels deep
      fall.style.transform = "translate3d(0," + (-p * 18).toFixed(2) + "%,0)";
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
  }
})();
